import { environment } from 'src/environments/environment';

export const isGakkoDev = !environment.production && window.location.origin.startsWith('https://localhost:5001');
